// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import hearingTranscriptEntity from './entities/hearing-transcript.json';
import hearingTranscriptMenu from '../pages/hearing-transcript/menu.json';
import hearingTranscriptFullForm from '../pages/hearing-transcript/forms/full.json';
import hearingTranscriptContextForm from '../pages/hearing-transcript/forms/context.json';
import hearingTranscriptMiniForm from '../pages/hearing-transcript/forms/mini.json';
import hearingTranscriptLookupForm from '../pages/hearing-transcript/forms/lookup.json';
import hearingTranscriptTableView from '../pages/hearing-transcript/views/table.json';
import hearingTranscriptCardsView from '../pages/hearing-transcript/views/cards.json';
import hearingTranscriptCalendarView from '../pages/hearing-transcript/views/calendar.json';
import hearingTranscriptDashboardView from '../pages/hearing-transcript/views/dashboard.json';

/** Тип запису «Стенограма» зі сторінками пакета: меню, форми та подання з pages/hearing-transcript/. */
export const hearingTranscriptDefinition: IRecordTypeDefinition = {
  ...hearingTranscriptEntity,
  views: assembleViewSet({
      table: hearingTranscriptTableView,
      cards: hearingTranscriptCardsView,
      calendar: hearingTranscriptCalendarView,
      dashboard: hearingTranscriptDashboardView,
  }),
  form: hearingTranscriptFullForm,
  forms: { full: hearingTranscriptFullForm, context: hearingTranscriptContextForm, mini: hearingTranscriptMiniForm, lookup: hearingTranscriptLookupForm },
  menu: hearingTranscriptMenu,
} as IRecordTypeDefinition;
